import type { VariantCombination } from "../types";

export function matchesPrefix(
  combination: VariantCombination,
  prefix: readonly string[],
) {
  for (let index = 0; index < prefix.length; index += 1) {
    if (combination.values[index] !== prefix[index]) return false;
  }
  return true;
}
